var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1111 8.88892H15.5556C14.3768 8.88892 13.2464 9.35717 12.4129 10.1907C11.5794 11.0242 11.1111 12.1546 11.1111 13.3334V66.6667C11.1111 67.8454 11.5794 68.9759 12.4129 69.8094C13.2464 70.6429 14.3768 71.1111 15.5556 71.1111H51.1111C52.2899 71.1111 53.4203 70.6429 54.2538 69.8094C55.0873 68.9759 55.5556 67.8454 55.5556 66.6667V53.3334H34.7333C34.144 53.3334 33.5787 53.0992 33.162 52.6825C32.7452 52.2657 32.5111 51.7005 32.5111 51.1111C32.5111 50.5218 32.7452 49.9565 33.162 49.5398C33.5787 49.123 34.144 48.8889 34.7333 48.8889H55.5556V13.3334C55.5556 12.1546 55.0873 11.0242 54.2538 10.1907C53.4203 9.35717 52.2899 8.88892 51.1111 8.88892Z",
    fill: "#728EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5778 38.4C62.1527 38.036 61.6058 37.8457 61.0466 37.8673C60.4873 37.8889 59.9567 38.1208 59.561 38.5165C59.1652 38.9123 58.9334 39.4428 58.9118 40.0021C58.8902 40.5614 59.0804 41.1082 59.4444 41.5333L66.9556 48.8889H55.5556V53.3333H66.9556L59.4444 61.0222C59.2118 61.2214 59.0229 61.4666 58.8895 61.7423C58.7561 62.018 58.6812 62.3183 58.6693 62.6243C58.6575 62.9304 58.7091 63.2356 58.8208 63.5207C58.9325 63.8059 59.102 64.0649 59.3186 64.2815C59.5351 64.498 59.7941 64.6675 60.0793 64.7792C60.3645 64.8909 60.6696 64.9425 60.9757 64.9307C61.2817 64.9188 61.582 64.8439 61.8577 64.7105C62.1334 64.5771 62.3786 64.3882 62.5778 64.1556L75.5556 51.2667L62.5778 38.4Z",
    fill: "#728EBC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.3b605bffe994292c2314462eede55fe3.svg";
export { ForwardRef as ReactComponent };